var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 291.37 224.26",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mail") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.32,35.6,127.57,150.48a30.33,30.33,0,0,0,45.5,0L272.56,37.59a10.48,10.48,0,0,1,2.82-2.22,34.18,34.18,0,0,0-13.76-2.89H39a34.3,34.3,0,0,0-13.21,2.64C26,35.29,26.16,35.42,26.32,35.6Z",
    transform: "translate(-4.63 -32.48)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.71,48.6a10.77,10.77,0,0,1-1.94,3.28L189.28,164.76a51.94,51.94,0,0,1-77.92,0L10.12,49.89c-.21-.24-.35-.5-.53-.74a34.21,34.21,0,0,0-5,17.72V222.35A34.39,34.39,0,0,0,39,256.74h222.6A34.39,34.39,0,0,0,296,222.35V66.87A34.22,34.22,0,0,0,290.71,48.6Z",
    transform: "translate(-4.63 -32.48)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.3e08046756911b3bb99e0037d7c2d718.svg";
export { ForwardRef as ReactComponent };